import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCompPopup: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';

		let commCdType = searchParams.commCdType;
		let causPartNo = '';
		if (searchParams.causPartNo !== null) {
			causPartNo = searchParams.causPartNo.slice(0, 5);
		}

		if (searchParams.commCdType !== undefined) {
			queryStr = objectToQuerystring({
				//commCdType: searchParams.commCdType,
				commCd: searchParams.commCd,
				causPartNo: causPartNo,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/commpopup/comCdPopup/v1/comCds/commCdType/` + commCdType + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
